var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagMaturity = function SvgTagMaturity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 0 8 8 8.012 8.012 0 0 0-8-8Zm2.44 11.756a.717.717 0 0 1-1.012 0L7.061 9.39V4.51c0-.395.32-.715.715-.716.395.001.715.32.716.716v4.287l1.948 1.947c.28.279.28.731 0 1.011Z",
    fill: "#AFAFAF"
  })));
};
export default SvgTagMaturity;